angular
	.module 'App.Module.Shop', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'shops',
				url: '/shops'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@shops':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: "Backoffice.TopMenu.Shops"
					searchParams:
						repositoryName: 'ShopRepository'
						title: 'general.shops'
						filterEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableSearch'
						createEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableSearch'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					priceRegions: (PriceRegionRepository) ->
						return PriceRegionRepository.getEntities()
					layoutTemplates: (ConfigurationService, LayoutTemplateRepository, BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE) ->
						if ConfigurationService.isDisabled 'Backoffice.Permission.LayoutTemplates.Enabled'
							return

						query = LayoutTemplateRepository.getQuery()
						query.criteria 'entity_type', '!=', BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.PREDEFINED

						return LayoutTemplateRepository.getEntities(query)

			.state 'shops.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					shop: (ShopRepository, $stateParams) ->
						query = ShopRepository.createQuery()
						query.with 'company', 'shop_opening_hours', 'sales_taxes'
						query.withIds 'shop_groups', 'data_sources', 'sales_taxes>excluded_product_categories'

						return ShopRepository.getEntity $stateParams.id, query

					stockLocations: (StockLocationRepository) ->
						return StockLocationRepository.getEntities()

					shopConfigurations: (ConfigurationRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return []

						return ConfigurationRepository.listShopConfigurations($stateParams.id)

					shopGroups: (shop, ConfigurationService, ShopGroupRepository) ->
						if _.isEmpty(shop.shop_groups) || ConfigurationService.isDisabled('Backoffice.ShopManagement.Shops.EnableShopGroups')
							return []

						query = ShopGroupRepository.createQuery()
						query.criteria 'id', 'IN', shop.shop_groups.join()

						return ShopGroupRepository.getEntities query

					dataSources: (shop, ConfigurationService, DataSourceRepository) ->
						if _.isEmpty(shop.data_sources) || ConfigurationService.isDisabled('Backoffice.ShopManagement.Shops.EnableDataSources')
							return []

						query = DataSourceRepository.createQuery()
						query.criteria 'id', 'IN', shop.data_sources.join()

						return DataSourceRepository.getEntities(query)

					productCategories: (shop, ConfigurationService, ProductCategoryRepository) ->
						if _.isEmpty(shop.sales_taxes) || ConfigurationService.isDisabled('Shared.Setting.SalesTax.Enabled')
							return []

						categoryIds = []

						for salesTax in shop.sales_taxes
							if !_.isEmpty(salesTax.excluded_product_categories)
								categoryIds = _.union(categoryIds, salesTax.excluded_product_categories)

						if _.isEmpty(categoryIds)
							return []

						query = ProductCategoryRepository.createQuery()
						query.criteria 'id', 'IN', categoryIds.join()

						return ProductCategoryRepository.getEntities(query)

					shopTables: (ShopTableRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return []

						query = ShopTableRepository.createQuery()
						query.criteria('shop_id', '=', $stateParams.id)
						query.sortBy('create_time', 'DESC')

						return ShopTableRepository.getEntities(query)

					registers: (RegisterRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return []

						query = RegisterRepository.createQuery()
						query.criteria('shop_id', '=', $stateParams.id)

						return RegisterRepository.getEntities(query)

					languages: (PublicRepository) ->
						return PublicRepository.getTranslatedLanguages()

					vatRateOverrideGroups: (ConfigurationService, VatRateOverrideGroupRepository) ->
						if ConfigurationService.isDisabled('Shared.Setting.LinkShopToVatRateOverrideGroup.Enabled')
							return

						return VatRateOverrideGroupRepository.getEntities()

			.state 'shops.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'ShopController'
						controllerAs: 'vm'
						templateUrl: '@app/shop/shop.view.html'
